<p-dialog
  class="pdf-content-dialog"
  header="Select PDF Content"
  [(visible)]="isVisible"
  [dismissableMask]="true"
  [modal]="true"
  (onHide)="closeDialog.emit()">
  <div class="pdf-content-dialog__options">
    @for (option of contentOptions; track $index) {
      <div class="pdf-content-dialog__option">
        <p-checkbox [inputId]="option.value" [value]="option.value" [(ngModel)]="selectedContent"></p-checkbox>

        <label [for]="option.value">{{ option.label }}</label>
      </div>
    }
  </div>

  <div class="pdf-content-dialog__actions ">
    <p-button label="Cancel" severity="secondary" (onClick)="closeDialog.emit()" />
    <p-button label="Download" (onClick)="onDownload()" [disabled]="!selectedContent.length" />
  </div>
</p-dialog>
